<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">공지사항관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>제목</p>
                <input type="text" placeholder="제목을 입력하세요" class="form_control" v-model="searchInfo.title">
              </li>
              <li>
                <p>작성일자</p>
                <Datepicker v-model="searchInfo.startDt" :defaultDate="searchInfo.startDate" :format="'YYYY-MM-DD'" /> 
                <span>~</span>
                <Datepicker v-model="searchInfo.endDt" :defaultDate="searchInfo.endDt" :format="'YYYY-MM-DD'"/> 
              </li>              
              <li>
                <p>공지상태</p>
                <div class="form_radio">
                  <input type="radio" id="radio1" name="radio" value="" checked v-model="searchInfo.noticeStatus">
                  <label for="radio1">전체</label>
                </div>
				        <div  class="form_radio" v-for="(item, index) in noticeStatusList" :key="index">
                  <input type="radio" :id="index" name="radio" :value="item.dtl_code" v-model="searchInfo.noticeStatus">
                  <label :for="index">{{item.dtl_code_nm}}</label>
                </div>                                     
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <div class="table_option">
              <div class="form_select"></div>
              <button class="btn btn_md btn_darkblue" @click="fn_move_reg_page">신규 등록</button>
            </div>            
            <table class="list">
              <thead>
                <tr>
                    <th>No</th>
                    <th>작성일자</th>
                    <th>제목</th>
                    <th>공지기간</th>
                    <th>타입</th>
					          <th>조회수</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="noticeList.length == 0">
                    <td colspan="6"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(td, index) in noticeList" :key="index" @click="fn_move_dtl_page(td.board_notice_id)">
                  <td><span>{{ td.no ? td.no : index + 1 }}</span></td>
                  <td><span>{{ td.reg_dt }}</span></td>
                  <td class="al"><span>{{ td.board_notice_title }}</span></td>
                  <td><span>{{ td.board_notice_start_dt}} ~ {{td.board_notice_end_dt}}</span></td>
                  <td><span>{{ td.board_notice_status_nm }}</span></td>
                  <td><span>{{ td.read_cnt }}</span></td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo="searchInfo.pageInfo"  v-show="pagingShow"/>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
  import axios from 'axios'
  import Pagination from "@/components/AdminPagination.vue"
  import Datepicker from '@/components/Datepicker.vue'
  import commonUtil from "@/mixin/commonUtil";

  export default {
    name: 'NoticeMngt',
    components: {
      Pagination,
      Datepicker
    },
	mixins: [commonUtil],
    data() {
      return {
        searchInfo : {
          title : '',
          startDate : '',
          endDate : '',
          noticeStatus : '',
          pageInfo : {
            page : 1,
            pageSize : 5,
            totPage : 0
          }                
        },
		    pagingShow : false,
        noticeList: [],
		    noticeStatusList : []
      }
    },
	async created(){
      //공통코드 - 공지사항상태
      this.noticeStatusList = await this.getCode('GC00000004');         
		  console.log("@@@@ noticeStatusList : %o",this.noticeStatusList);
		  this.fn_search();
    },
	methods : {
		    fn_move_reg_page(){
            this.$router.push("/admin/board/noticeMngtReg");
        },
        fn_search(){
            axios
                .post("/api/admin/board/searchNotice", this.searchInfo)
                .then((res) => {
                    console.log("@@@@ res : %o",res);
                    this.noticeList = res.data.noticeInfo;

                    console.log("@@@@ noticeList : %o",this.noticeList);

                    this.searchInfo.pageInfo.totPage = res.data.totCnt;
                    
                    if(this.searchInfo.pageInfo.totPage> 0){
                        this.pagingShow = true;                          
                    }                        

                })
                .catch((err) => console.log(err));
        },
		fn_move_dtl_page(boardNoticeId){

			this.$store.dispatch('notice/setBoardNoticeId', boardNoticeId);             
			this.$router.push("/admin/board/noticeMngtDtl");			
		}
	}
  }
</script>